<template>
    <el-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        title="我的其他App"
        width="1200px"
        append-to-body
        :before-close="handleClose">
        <div class="content-wrap ml20">
            <div class="mb20">
                <el-input v-model="name" clearable placeholder="请输入App名称或ID关键字搜索" style="width:240px;">
                    <i slot="suffix" class="el-input__icon el-icon-search"></i>
                </el-input>
            </div>
            <div class="data-list">
                <el-table
                    border
                    :header-cell-style="{background:'#e8eaec',color:'#333'}"
                    :data="c_list"
                    style="width: 100%;"
                    ref="multipleTable"
                    @selection-change="handleSelectionChange"
                    v-loading="loading"
                >
                    <el-table-column
                        type="selection"
                        width="50"
                        align="center"
                        fixed="left"
                    >
                    </el-table-column>
                    <el-table-column
                        prop="app_name"
                        label="App 名称"
                        min-width="220">
                    </el-table-column>
                    <el-table-column
                        prop="adam_id"
                        label="App ID"
                        min-width="150">
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <div slot="footer" class="dialog-footer tac">
            <el-button type="default" @click="handleClose" class="action-btn ml20">取消</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="submitLoading" :disabled="dataList.length<=0" class="action-btn ml20">提交</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import API from '@/api/marketManage/apple/index';
    export default {
        name: "createSelectOutAppModal",
        props:{
            // title:{
            //     type:String,
            //     default:'添加关键词',
            // },
            // actionRows:Array,
            // originPage:{
            //     type:String,
            //     required:true,
            // },
            select: Array
        },
        data(){
            return {
                dialogVisible:false,
                submitLoading:false,
                name: '', //名字搜索
                orgList:[],
                campaignList:[],
                adGroupList:[],
                dataList:[
                    // {
                    //     "app_name": "[拳皇97]",
                    //     "adam_id": "999999",
                    // },
                    // {
                    //     "app_name": "[我要修仙]",
                    //     "adam_id": "456789",
                    // },
                ],
                loading:false,
                multipleSelection:[],
            }
        },
        computed:{
            c_list: function () {
                let res_list = this.dataList.filter(item=>{
                    if( (item['app_name'].indexOf(this.name) != -1) || (item['adam_id'].indexOf(this.name) != -1) ) {
                        return true
                    }else{
                        return false
                    }
                })
                return res_list
            }
        },

        methods:{
            handleClose(val){
                this.dialogVisible = false;
                this.resetForm();
            },
            resetForm(){
                this.name = '';
                this.submitLoading = false;
            },
            handleSubmit(){
                if(this.multipleSelection.length == 0) {
                    this.$message.error('请选择App')
                    return
                }
                this.$emit('getOutApp', this.multipleSelection)
                this.dialogVisible = false;
            },
            showModal(params, org_id){
                this.loading = true
                API.getPromotionAppOptions({org_id:org_id}).then(res=>{
                    this.dataList = res.data
                    // this.multipleSelection = this.select
                    if(params.length == 0) {
                        this.multipleSelection = []
                        
                    }else{
                        if(this.dataList.length != 0) {
                            let mul_arr = []
                            this.dataList.forEach(item => {
                                let selectIndex = params.findIndex((element) => element['adam_id'] == item.adam_id)
                                if(selectIndex != -1) {
                                    this.$nextTick(()=>{
                                        this.$refs.multipleTable.toggleRowSelection(item);
                                    })
                                    mul_arr.push(item)
                                }
                            });
                            this.multipleSelection = mul_arr
                        }
                    }
                    this.loading = false
                }, err=>{
                    this.loading = false
                    if (err.code == '403') {
                        this.$confirm(err.info||'请求异常', '提示', {
                            confirmButtonText: '刷新',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                        });
                        return
                    }
                })
                
                this.dialogVisible = true;
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            }
        },
    }
</script>

<style lang="scss" scoped>
    .tool-bar{
        height: 50px;
        background-color: #f2f2f2;
        /*border: solid silver 1px;*/
        padding: 10px;
        margin: 10px 0;
        .add-input{
            width: calc(100% - 120px);
        }

        .batch-tool{
            height: 28px;
            line-height: 26px;
            background-color: #fff;
            border: solid silver 1px;
            padding-left: 10px;
        }
    }

    .mb6{
        margin-bottom: 6px;
    }

</style>
